module.exports = "<div class=\"content-box\">\r\n    <h2 class=\"header-major\">Page not found</h2>\r\n    <p>We couldn't find the page you were looking for. Do you have the right URL?</p>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// C:/Users/Alec/Documents/dev/recog/recog/src/app/app-core/not-found/not-found.component.html
// module id = ../../../../../src/app/app-core/not-found/not-found.component.html
// module chunks = main